export default __webpack_public_path__ + "static/media/iron.57505ab9.png";